<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">RS Lenke</h4>
      </div>
    </div>

    <div class="grid-x" style="padding: 1.5rem;">
      <div class="cell">
        <div class="input-container textarea">
          <label>Objektnummer (En per linje)</label>
          <textarea v-model="objectNumber" @input="handleInput" rows="20"></textarea>
        </div>
      </div>
      <div class="cell">
        <div class="grid-x">
          <div class="cell auto" style="padding-right: 5px;">
            <button
              href="javascript:;"
              class="button primary large"
              style="width: 100%;"
              :disabled="isLoading || isRsUrlEmpty"
              @click="copyToClipboard"
            >
              <span>Kopiere</span>
            </button>
          </div>
          <div class="cell auto" style="left: 5px;">
            <a
              :href="getRsUrl()"
              target="_blank"
              class="button primary large"
              style="width: 100%;"
              :disabled="isLoading || isRsUrlEmpty"
            >
              <span>Gå til</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/services/Api'

export default {
  name: 'RSLink',
  data () {
    return {
      isLoading: false,
      objectNumber: '',
      linesArray: [],
      objectIds: [],
      typingTimeout: null
    }
  },
  computed: {
    isRsUrlEmpty () {
      return this.getRsUrl() === ''
    }
  },
  methods: {
    handleInput () {
      this.objectIds = []
      clearTimeout(this.typingTimeout)

      this.typingTimeout = setTimeout(() => {
        this.linesArray = this.objectNumber.split('\n')
        this.fetchObjekt()
      }, 1000)
    },
    fetchObjekt: function () {
      this.isLoading = true
      Api()
        .post('/objekt/search.json?limit=1000', { object_numbers: this.linesArray.join(',') })
        .then((response) => {
          response.data.data.forEach((item) => {
            this.objectIds.push(item.Objektid)
          })
          this.isLoading = false
        })
        .catch((error) => {
          this.$helpers.sendApiErrorsToValidator(error, this.errors)
          if (this.errors.any()) {
            this.$validator.resume()
            this.$helpers.showErrorAlert('Kunne ikke hente auksjoner')
          }
          this.isLoading = false
        })
    },
    getRsUrl () {
      if (!this.objectIds.length) {
        return ''
      }
      return `https://media.blomqvist.no/pages/search.php?search=+objektid:${this.objectIds.join(';')}&archive=0&restypes=Global,1,2,3,4&access=`
    },
    copyToClipboard () {
      const url = this.getRsUrl()
      if (!url) return
      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$helpers.showSuccessAlert('URL kopiert til utklippstavlen!')
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Kunne ikke kopiere URL.')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/RSLink.vue